import { Injectable } from '@angular/core';

export interface UserInfo {
  id: number;
  email: string;
  fullName: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthHelperService {
  private readonly USER_KEY = 'user';
  private readonly TOKEN_KEY = 'auth_token';

  constructor() {}

  isAuthenticated(): boolean {
    const token = this.getToken();
    const user = this.getUser();
    return !!(token && user);
  }

  getToken(): string | null {
    const token = localStorage.getItem(this.TOKEN_KEY);
    if (!token) {
      return null;
    }

    if (this.isTokenExpired(token)) {
      this.clearAuth();
      return null;
    }

    return token;
  }

  getUser(): UserInfo | null {
    const userStr = localStorage.getItem(this.USER_KEY);
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }

  setUser(user: UserInfo): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    this.emitAuthStateChanged();
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
    this.emitAuthStateChanged();
  }

  clearAuth(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
    this.emitAuthStateChanged();
  }

  getUserName(): string | null {
    const user = this.getUser();
    return user?.fullName || null;
  }

  getUserEmail(): string | null {
    const user = this.getUser();
    return user?.email || null;
  }

  private emitAuthStateChanged(): void {
    window.dispatchEvent(new CustomEvent('auth-state-changed'));
  }

  private isTokenExpired(token: string): boolean {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return true;
      }

      const payload = JSON.parse(atob(parts[1]));
      if (!payload || typeof payload.exp !== 'number') {
        return true;
      }

      // Consider token expired slightly early to avoid edge cases during requests.
      const nowInSeconds = Math.floor(Date.now() / 1000);
      const expirySkewSeconds = 30;
      return payload.exp <= nowInSeconds + expirySkewSeconds;
    } catch {
      return true;
    }
  }
}




